const eventBus = new EventTarget();

export const SELECT_OPEN_EVENT = 'select-open';

export const dispatchSelectOpen = (id: string) => {
  eventBus.dispatchEvent(new CustomEvent(SELECT_OPEN_EVENT, { detail: { id } }));
};

export const onSelectOpen = (callback: (id: string) => void) => {
  const handler = (event: Event) => {
    const customEvent = event as CustomEvent;
    callback(customEvent.detail.id);
  };
  eventBus.addEventListener(SELECT_OPEN_EVENT, handler as EventListener);

  return () => {
    eventBus.removeEventListener(SELECT_OPEN_EVENT, handler as EventListener);
  };
};